import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { HeadersService } from '../services/header.service';

@Injectable()
export class RequestInterceptor implements HttpInterceptor {
  constructor(private routerService: Router, private headersService: HeadersService) {}

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const idCliente = localStorage.getItem('idCliente');
    const idUsuarioWeb = localStorage.getItem('idUsuarioWeb');
    const token = localStorage.getItem('token');
    let headersToUpdate: any = {};
    if (token !== 'null') {
      headersToUpdate = {
        Authorization: 'Bearer ' + token
        // OAUTH_TOKEN_STRING: 'Bearer ' + token
      };
    }
    if (!request.headers.has('ID-CLIENTE') && idCliente) {
      headersToUpdate['ID-CLIENTE'] = idCliente;
    }

    if (idCliente && idUsuarioWeb) {
      headersToUpdate['ID-USUWEB-USW'] = idUsuarioWeb;
    }

    headersToUpdate['URL-SITE'] = this.routerService.url;

    this.headersService.currentObject.subscribe((value) => {
      let obj;
      if (value) {
        obj = value.find((v) => request.url.includes(v.url));
      }
      if (obj) {
        headersToUpdate['FILE-NAME-SITE'] = obj.fileName;
      }
    });

    request = request.clone({
      setHeaders: headersToUpdate
    });

    return next.handle(request);
  }
}
